import { DateTime } from "luxon"

export function detectIanaZone(): string {
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
        return tz || "UTC"
    } catch {
        return "UTC"
    }
}

export function toOutlookUtcFromNaive(
    localText: string, // "YYYY-MM-DD HH:mm" | "YYYY-MM-DD HH:mm:ss"
): { isoUtc: string; jsDate: Date; zoneUsed: string } {
    const zoneUsed = detectIanaZone()
    const text = localText.trim()
    const format = text.length === 19 ? "yyyy-LL-dd HH:mm:ss" : "yyyy-LL-dd HH:mm"

    const dt = DateTime.fromFormat(localText, format, {
        zone: zoneUsed,
    })

    if (!dt.isValid) {
        throw new Error(dt.invalidExplanation ?? "Invalid datetime")
    }

    const isoUtc = dt.toUTC().toISO({ suppressMilliseconds: true })! // "YYYY-MM-DDTHH:mm:ssZ"
    return { isoUtc, jsDate: new Date(isoUtc), zoneUsed }
}
